import {DeleteOutlined, EditOutlined, EyeOutlined} from '@ant-design/icons';
import PropTypes from 'prop-types';
import React, {memo, useCallback, useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';

import EntityMenu from '@/components/EntityMenu';
import useCrud, {showConfirm} from '@/hooks/useCrud';
import {usePermissions} from '@/hooks/usePermissions';

const options = [
  {
    icon: <EyeOutlined/>,
    title: 'details',
    action: 'details',
    permissions: 'READ',

  },
  {
    icon: <EditOutlined/>,
    title: 'edit',
    action: 'edit',
    style: {minWidth: 160},
    permissions: 'WRITE',
  },
  {
    title: 'remove',
    action: 'remove',
    divider: true,
    permissions: ['WRITE'],
  },
  {
    icon: <DeleteOutlined/>,
    title: 'remove',
    action: 'remove',
    permissions: 'DELETE',
  }
];

export const createEntityRowAction = (service, fieldConfirm, name, translate, path, entityName, actions = {
  remove: true,
  edit: true,
  details: true
}, filterFunc) => {
  const EntityRowActions = ({entity, canEdit, canRemove}) => {
    const {push} = useHistory();
    const {t} = useTranslation(translate);
    const {remove, isLoading} = useCrud(service, name);
    const {optionsByPermissions} = usePermissions(entityName, entity, path);

    const renderOptions = useMemo(() => {
      return optionsByPermissions(options, entityName, actions, true);
    }, [optionsByPermissions]);

    const handleClick = useCallback(({action}) => {
      switch (action) {
        case 'details': {
          push(`${path}/${entity?._id}`);
          break;
        }
        case 'edit': {
          push(`${path}/${entity?._id}/edit`);
          break;
        }

        case 'remove': {
          showConfirm(t, entity[fieldConfirm], () => remove(entity._id));
          break;
        }
        default: {
          console.log('missing action handler');
        }
      }
    }, [push, remove, t, entity]);

    // const menuOptions = useMemo(() => options.filter(e => actions[e.action] && (filterFunc ? filterFunc(e.action, entity) : true)), [entity]);

    const menuOptions = useMemo(
      () =>
        renderOptions.filter(
          (e) =>
            actions[e.action] &&
            (filterFunc ? filterFunc(e.action, entity) : true)
        ),
      [entity, renderOptions]
    );

    return (
      <EntityMenu
        disabled={!menuOptions || !menuOptions.length}
        options={menuOptions}
        hide={{
          edit: !canEdit,
          remove: !canRemove
        }}
        translate={translate}
        onClick={handleClick} isLoading={isLoading}/>
    );

  };

  /**
   * cellRender
   * */
  /**
   * This is not a component,
   * it is a function to render the Status component in a table cell
   * @param {String} text this is the value of the dataIndex of the table (we will ignored in this case)
   * @param {Object} user this is the row instance
   * */

  EntityRowActions.propTypes = {
    canEdit: PropTypes.bool,
    canRemove: PropTypes.bool,
    entity: PropTypes.object
  };
  EntityRowActions.defaultProps = {
    canEdit: true,
    canRemove: true
  };

  const Component = memo(EntityRowActions);

  const renderEntityActions = (id, entity) => {
    return (
      <Component entity={entity}/>
    );
  };
  return {
    Component,
    renderEntityActions
  };
};

